module.exports = __webpack_public_path__ + "img/wrench.912519ec.svg";